var map = {
	"./amz.png": 9675,
	"./android.png": 4942,
	"./androidtv copy.png": 625,
	"./applelog.png": 1741,
	"./chrom.png": 9378,
	"./formuller.png": 2565,
	"./huawei.png": 9764,
	"./lg.png": 5504,
	"./lonov.png": 5355,
	"./micro.png": 1215,
	"./phili.png": 3399,
	"./sams.png": 8263,
	"./sharp.png": 9655,
	"./sony.png": 6422,
	"./tcl.png": 906,
	"./tosh.png": 6357,
	"./x96.png": 7262,
	"./xiaomi.png": 5864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;